/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Product_Image_DimensionsInputs */

const vi_error_product_image_dimensions = /** @type {(inputs: Error_Product_Image_DimensionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ảnh có cạnh dài quá ${i?.max} px. Thu nhỏ ảnh rồi thử lại.`)
};

/**

* @param {Error_Product_Image_DimensionsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_product_image_dimensions = /** @type {((inputs: Error_Product_Image_DimensionsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Image_DimensionsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_product_image_dimensions(inputs)
});